import { createApp } from "vue";
import { createPinia } from "pinia";

export function mountVueComponent(
  component,
  element: string | Element,
  rootProps = {}
) {
  const pinia = createPinia();
  const app = createApp(component, rootProps);

  app.use(pinia);
  app.mount(element);

  return app;
}
